import {
  MASTER_MERCHANT_REQUEST,
  MASTER_MERCHANT_REQUEST_SUCCESS,
  MASTER_MERCHANT_CLEAN_REQUEST,
  MASTER_MERCHANT_REQUEST_FAILURE,
  MASTER_MERCHANT_DETAILS_REQUEST,
  MASTER_MERCHANT_DETAILS_REQUEST_SUCCESS,
  MASTER_MERCHANT_DETAILS_REQUEST_FAILURE,
  MASTER_MERCHANT_DETAILS_CLEAN_REQUEST,
  MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST,
  MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_SUCCESS,
  MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_FAILURE,
  MASTER_MERCHANT_EXPANDED_DETAILS_CLEAN_REQUEST,
  MASTER_MERCHANT_GROUP_LIST_CLEAN_REQUEST,
  MASTER_MERCHANT_GROUP_LIST_REQUEST_FAILURE,
  MASTER_MERCHANT_GROUP_LIST_REQUEST_SUCCESS,
  MASTER_MERCHANT_GROUP_LIST_REQUEST,
  CREATE_MASTER_MERCHANT_CLEAN_REQUEST,
  CREATE_MASTER_MERCHANT_REQUEST_FAILURE,
  CREATE_MASTER_MERCHANT_REQUEST_SUCCESS,
  CREATE_MASTER_MERCHANT_REQUEST,
  EDIT_MASTER_MERCHANT_CLEAN_REQUEST,
  EDIT_MASTER_MERCHANT_REQUEST_FAILURE,
  EDIT_MASTER_MERCHANT_REQUEST_SUCCESS,
  EDIT_MASTER_MERCHANT_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};
const DETAILS_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const GROUP_LIST_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const MASTER_INITIAL_STATE = {
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const superMerchantReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case MASTER_MERCHANT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MASTER_MERCHANT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case MASTER_MERCHANT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MASTER_MERCHANT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};
const superMerchantDetailsReducer = (state, action) => {
  state = state || DETAILS_INITIAL_STATE;

  switch (action.type) {
    case MASTER_MERCHANT_DETAILS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MASTER_MERCHANT_DETAILS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case MASTER_MERCHANT_DETAILS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MASTER_MERCHANT_DETAILS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
const superMerchantExpandedDetailsReducer = (state, action) => {
  state = state || DETAILS_INITIAL_STATE;

  switch (action.type) {
    case MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case MASTER_MERCHANT_EXPANDED_DETAILS_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MASTER_MERCHANT_EXPANDED_DETAILS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

const masterMerchantGroupListReducer = (state, action) => {
  state = state || GROUP_LIST_INITIAL_STATE;

  switch (action.type) {
    case MASTER_MERCHANT_GROUP_LIST_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case MASTER_MERCHANT_GROUP_LIST_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case MASTER_MERCHANT_GROUP_LIST_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case MASTER_MERCHANT_GROUP_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
const createMasterMerchantReducer = (state, action) => {
  state = state || MASTER_INITIAL_STATE;

  switch (action.type) {
    case CREATE_MASTER_MERCHANT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case CREATE_MASTER_MERCHANT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
      });

    case CREATE_MASTER_MERCHANT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case CREATE_MASTER_MERCHANT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
const editMasterMerchantReducer = (state, action) => {
  state = state || MASTER_INITIAL_STATE;

  switch (action.type) {
    case EDIT_MASTER_MERCHANT_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case EDIT_MASTER_MERCHANT_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
      });

    case EDIT_MASTER_MERCHANT_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case EDIT_MASTER_MERCHANT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export {
  superMerchantReducer,
  superMerchantDetailsReducer,
  superMerchantExpandedDetailsReducer,
  masterMerchantGroupListReducer,
  createMasterMerchantReducer,
  editMasterMerchantReducer,
};
